// TODO: REFACTORING
import React, { useState, useRef, useEffect } from 'react';
import Style from './style.module.css';
import './style.css';
import { translate as t } from '../../utils/translate';
import LazyLoad from 'react-lazyload';
import AircraftGallerySlider from './components/AircraftGallerySlider';
import PlaceholderImageLoading from './components/PlaceholderImageLoading';

const AircraftGallery = ({
  images,
  flightPage,
  className,
  onToggleModal,
  isModal,
}) => {
  const [firstImage, ...otherImages] = images;
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false);
  const [slickGoIndex, setSlickGoIndex] = useState(null);
  const [galleryOpened, setGalleryModal] = useState(false);

  const featuredSliderRef = useRef();
  const navSliderRef = useRef();

  const toggleModal = (modalState, index = null) => {
    setSlickGoIndex(index);
    if (!hasOpenedOnce) {
      setHasOpenedOnce(true);
    }
    setGalleryModal(modalState);
    if (onToggleModal) onToggleModal(modalState);
    document.documentElement.style.overflow = modalState ? 'hidden' : 'scroll';
  };

  useEffect(() => {
    if (galleryOpened && navSliderRef.current != null && slickGoIndex) {
      navSliderRef.current.slickGoTo(slickGoIndex, true);
    }
  }, [galleryOpened]);

  useEffect(() => {
    if (slickGoIndex && navSliderRef.current) {
      navSliderRef.current.slickGoTo(slickGoIndex, true);
    }
  }, [hasOpenedOnce]);

  const TEXTS = {
    AIRCRAFT_LABEL: t('aircraft'),
    SEE_ALL: t('seeAll'),
  };
  return (
    <>
      {flightPage && (
        <div
          className={[
            Style.flightSectionTitle,
            'container',
            'path-gallery-title',
          ].join(' ')}
        >
          {TEXTS.AIRCRAFT_LABEL}
        </div>
      )}
      <section
        className={[
          Style.gallery,
          'aircraftGallery',
          'container',
          className,
          flightPage ? Style.flightPage : '',
        ].join(' ')}
      >
        {firstImage && (
          <div
            className={
              isModal
                ? [
                    Style.firstImageContainer,
                    Style.firstImageContainerModal,
                  ].join(' ')
                : Style.firstImageContainer
            }
            onClick={() => {
              isModal ? toggleModal(false) : toggleModal(true, 0);
            }}
          >
            <LazyLoad
              once
              offset={100}
              placeholder={<PlaceholderImageLoading />}
            >
              <img
                className={Style.firstImage}
                src={firstImage.url}
                alt={firstImage.label}
              />
            </LazyLoad>
          </div>
        )}
        <div
          className={
            isModal
              ? [
                  Style.otherImagesContainer,
                  Style.otherImagesContainerModal,
                ].join(' ')
              : Style.otherImagesContainer
          }
        >
          {otherImages
            .filter((image, index) => index < 4)
            .map(({ label, url }, index) => (
              <div
                key={index}
                className={Style.galleryItem}
                onClick={() => {
                  isModal ? toggleModal(false) : toggleModal(true, index + 1);
                }}
              >
                <LazyLoad
                  once
                  offset={1200}
                  height={'100%'}
                  placeholder={<PlaceholderImageLoading />}
                >
                  <img
                    className={Style.galleryItemImage}
                    src={url}
                    alt={label}
                  />
                </LazyLoad>
              </div>
            ))}
        </div>
        <span
          className={
            isModal
              ? [Style.showMoreModal]
              : [Style.showMore, 'pathShowMore'].join(' ')
          }
          onClick={() => (isModal ? toggleModal(false) : toggleModal(true))}
        >
          {TEXTS.SEE_ALL}
        </span>
        <div
          className={[
            Style.galleryModal,
            galleryOpened ? Style.opened : '',
            'aircraft-gallery__modal',
          ].join(' ')}
        >
          {hasOpenedOnce && (
            <AircraftGallerySlider
              featuredSliderRef={featuredSliderRef}
              navSliderRef={navSliderRef}
              images={images}
              toggleModal={toggleModal}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default AircraftGallery;
